/**
 * Build a stable category id from a display name (admin create form).
 */
export function slugifyCategoryId(name) {
  if (!name || typeof name !== 'string') return '';
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_-]/g, '')
    .replace(/_+/g, '_')
    .replace(/-+/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '')
    .slice(0, 50);
}

/**
 * Build section slug for URL segment (/catalog/:category/:sectionSlug).
 */
export function slugifySectionSlug(name) {
  if (!name || typeof name !== 'string') return '';
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '')
    .slice(0, 100);
}

/** Categories used only in catalog UI, not assignable to products. */
export function isReservedCategoryId(id) {
  return id === 'all';
}

export function categoryOptionsForProducts(categories) {
  if (!Array.isArray(categories)) return [];
  return categories.filter((cat) => cat?.id && !isReservedCategoryId(cat.id));
}
